import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { translate } from "../../i18n"
import { getGeneralApiProblem } from "../../services/api/api-problem"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"

const NewsStoreModelProp = {
  loading: types.maybeNull(types.boolean),
  // news: types.maybeNull(types.frozen()),
  // latestNews: types.maybeNull(types.frozen()),
  // categories: types.maybeNull(types.frozen()),
  news: types.optional(types.array(types.frozen()), []),
  selectedNews: types.maybeNull(types.frozen()),
  latestNews: types.optional(types.array(types.frozen()), []),
  categories: types.optional(types.array(types.frozen()), []),
  cacheToken: types.maybeNull(types.frozen()),
  link: types.maybeNull(types.frozen()),
  error: types.maybeNull(types.frozen()),
}

/**
 * Model description here for TypeScript hints.
 */
export const NewsStoreModel = types
  .model("NewsStore")
  .props(NewsStoreModelProp)
  .extend(withEnvironment)
  .extend(withRootStore)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof NewsStoreModelProp, value: any) {
      if (self[key] === value) return;
      self[key] = value as never;
    },
    setLoading: (loading: boolean) => {
      self.loading = loading
    },
    setNews: (news) => {
      self.news = news
    },
    setSelectedNews: (selectedNews) => {
      self.selectedNews = selectedNews
    },
    setLatestNews: (latest) => {
      self.latestNews = latest
    },
    setCategories: (categories) => {
      self.categories = categories
    },
    setCacheToken: (cacheToken) => {
      self.cacheToken = cacheToken
    },
    setLink: (link) => {
      self.link = link
    },
    setError: (error) => {
      self.error = error
    },
  })) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    fetchNews: async (token = null, params = {}, page = 1, text = "") => {
      const { tokenStore } = self.rootStore
      const accessToken = token || tokenStore.token.access_token
      self.setLoading(true);
      const search = text.length ? `?search=${text}` : ``
      const result: any = await self.apiSauce.get(`/posts${search}`, {
        with: 'author',
        sort: 'created_at,desc',
        per_page: 10,
        status: 'PUBLISHED',
        ...params,
      }, {
        headers: {
          Authorization : `Bearer ${accessToken}`
        }
      })
      self.setLoading(false);
      if (result.status === 200) {
        const { data, links } = result.data;
        if (page === 1) {
          const latest = data.slice(0, 5);
          self.setLatestNews(latest)
          self.setError(null)
          self.setNews(data)
          self.setLink(links)
        }
        if (page !== 1) {
          const arrNews = [...self.news]
          data.map((item) => arrNews.push(item))
          self.setLink(links)
          self.setNews(arrNews)
          self.setError(null)
        }
      } else {
        if (page === 1) {
          self.setNews([])
          self.setLink(null)
          self.setError(getGeneralApiProblem(result))
          self.rootStore.appStore.set("isOffline", true)
        }
      }
    }
  }))
  .actions((self) => ({
    searchNews: async (text: string, params: any) => {
      const { tokenStore: { token } } = self.rootStore

      self.setLoading(true);
      const result: any = await self.apiSauce.get(`/posts/?search=${text}`, params, {
        headers: {
          Authorization : `Bearer ${token.access_token}`
        }
      })
      self.setLoading(false);
      if (result.status === 200) {
        const { data, links } = result.data;
        self.setNews(data)
        self.setLink(links)
        self.setError(null);

      } else {
        self.setNews([])
        self.setLink(null)
        self.setError(getGeneralApiProblem(result))
      }
    }
  }))
  .actions((self) => ({
    fetchCategories: async (token: string) => {
      const { tokenStore } = self.rootStore
      const accessToken = token || tokenStore.token.access_token
      self.setLoading(true);
      const result: any = await self.apiSauce.get("/categories", {}, {
        headers: {
          Authorization : `Bearer ${accessToken}`
        }
      })
      self.setLoading(false);
      if (result.status === 200) {
        const { data } = result.data;
        const arrCategory = data;
        const name = translate("newsScreen.allCategory");
        arrCategory.unshift({ name, slug: null });
        self.setError(null)
        self.setCategories(arrCategory)
      } else {
        // __DEV__&& console.tron.log(result.status)
        self.setCategories(null)
        self.setError(getGeneralApiProblem(result))
      }
    }
  }))
  .actions((self) => ({
    fetchCacheToken: async () => {
      const token = self.rootStore.tokenStore.token.access_token;
      self.setLoading(true);
      const result: any = await self.apiSauce.post("/request_access", {}, {
        headers: {
          Authorization : `Bearer ${token}`
        }
      })
      self.setLoading(false);
      if (result.status === 200) {
        const { data } = result.data;
        self.setCacheToken(data.cache_key)
        self.setError(null)
      } else {
        // __DEV__&& console.tron.log(result.status)
        self.setCacheToken(null)
        self.setError(getGeneralApiProblem(result))
      }
    }
  }))
  .actions((self) => ({
    setStateNews: (data: any) => self.setSelectedNews(data)
  }))
type NewsStoreType = Instance<typeof NewsStoreModel>
export interface NewsStore extends NewsStoreType {}
type NewsStoreSnapshotType = SnapshotOut<typeof NewsStoreModel>
export interface NewsStoreSnapshot extends NewsStoreSnapshotType {}
export const createNewsStoreDefaultModel = () => types.optional(NewsStoreModel, {})
